export const isFreightServiceLevel = (serviceLevel) => serviceLevel?.includes('FREIGHT');